import React from "react";
import { OmniDropdownComponent, OmniStyleComponent, AlertMessagesService, MediaOpsService } from "../../../../shared";

export default class PlatformCampaignDialogComponent extends React.Component {

    defaultState = {
        dropdownValue: [],
        enableMapToPlacement: true
    };

    constructor(props) {
        super(props);
        this.state = this.defaultState;
    }

    /**
     * Close the model
     */
    closeModel = () => {
        this.props.closeModel();
        this.setState(this.defaultState);
    };

    /**
     * Map the platform campaign data to the campaign
     * @param {Object} event
     * @returns {void}
     * @memberof OrphanedDeliveredModelComponent
     */
    mapToCampaign = () => {
        this.props.setSpinnerCount(1);
        const selectedCount = this.props.selectedData.length;
        const dropdownValue = this.state.dropdownValue[0];
        // Payload to map the platform campaign data to the campaign
        const payload = {
            campaign_id: dropdownValue?.synthetic_id,
            id: this.props.selectedData,
            map: 'true'
        };
       
        MediaOpsService.mapPlatformCampaign(payload)
        .then((response) => {
            this.props.fetchCampaignTableData();
            // window.location.reload();
            this.props.setSpinnerCount(0);
            AlertMessagesService.showSuccessToastMessage(`You have mapped ${selectedCount} platform campaigns to the ${this.state.dropdownValue[0].value} campaign!`);
            this.props.closeModel(this.state.dropdownValue);
            this.setState(this.defaultState);
            this.props.setEnableMapToPlacement(true);
            this.props.fetchPlatformDeliveredData();
        }).catch((error) => {
            AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: this.mapToCampaign, title: `Unable to map ${selectedCount} platform campaigns to the ${this.state.dropdownValue[0].value} campaign!`, bodyMsgArr: []}]);
            this.props.setSpinnerCount(0);
        });
    };

    /**
     * Handle the dropdown change
     * @param {Object} event
     */
    handleDropdownChange = (event) => {
        const value = event.target.value;
        this.setState({ dropdownValue: value, enableMapToPlacement: false});
    };

    render() {
        const { isModelOpen, dropdownOptions } = this.props;
        return (<>
            {isModelOpen && (
                <div className="platform-modal-container">
                <OmniStyleComponent>
                <div className='platform-campaign-modal modal is-active'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <div className='modal-header-title'>
                                Map to campaign
                            </div>
                            <hr className='modal-header-divider' />
                            <div className='modal-header-description'>
                                Select a destination campaign you would like to map your objects to
                            </div>
                        </div>
                        <div className='modal-middle-section'>
                            <label htmlFor="platform-campaign-dropdown" className='modal-middle-section-label'>Campaign</label>
                            <OmniDropdownComponent
                            typeahead
                            hidefooter
                            searchindropdown
                            options={dropdownOptions}
                            placeholder='Select campaign'
                            value={this.state.dropdownValue}
                            id="platform-campaign-dropdown"
                            className="platform-campaign-dropdown"
                            onDropdownChange={this.handleDropdownChange}
                            />
                        </div>
                        <div className='modal-footer'>
                            <div className='modal-button-group'>
                                <button className='button is-text is-large' onClick={this.closeModel}>
                                    Cancel
                                </button>
                                <button className='button is-primary is-large' disabled={this.state.enableMapToPlacement} onClick={this.mapToCampaign}>
                                    Map to campaign
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                </OmniStyleComponent>
                </div>
            )}
        </>)
    };
};